import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Purchases from "@/pages/Purchases";
import PurchaseForm from "@/pages/PurchaseForm";
import PurchaseDetail from "@/pages/PurchaseDetail";
import Receiving from "@/pages/Receiving";
import ReceiveTask from "@/pages/ReceiveTask";
import Transfers from "@/pages/Transfers";
import TransferForm from "@/pages/TransferForm";
import TransferDetail from "@/pages/TransferDetail";
import PurchaseRequests from "@/pages/PurchaseRequests";
import DeliveryRequests from "@/pages/DeliveryRequests";
import Production, { ProductionDetail } from "@/pages/Production";
import Stock from "@/pages/Stock";
import Items from "@/pages/Items";
import Recipes from "@/pages/Recipes";
import Opname from "@/pages/Opname";
import OpnameForm from "@/pages/OpnameForm";
import OpnameDetail from "@/pages/OpnameDetail";
import Ledger from "@/pages/Ledger";
import Variance from "@/pages/Variance";
import SalesImport from "@/pages/SalesImport";
import Cash from "@/pages/Cash";
import Expenses from "@/pages/Expenses";
import Reports from "@/pages/Reports";
import Adjustments from "@/pages/Adjustments";
import SettingsPage from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";
import Assets from "@/pages/Assets";
import Payables from "@/pages/Payables";
import OpnameTemplates from "@/pages/OpnameTemplates";
import Reminders from "@/pages/Reminders";
import Consignment from "@/pages/Consignment";
import ConsignmentRecap from "@/pages/ConsignmentRecap";
import Review from "@/pages/Review";

function Gate() {
  const { user, meta } = useAuth();
  if (user === null || (user && !meta)) return <div className="min-h-screen grid place-items-center text-slate-500 text-sm">Memuat…</div>;
  if (!user) return <Login />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="purchases" element={<Purchases />} />
        <Route path="purchases/new" element={<PurchaseForm />} />
        <Route path="purchases/:id" element={<PurchaseDetail />} />
        <Route path="receiving" element={<Receiving />} />
        <Route path="receiving/:type/:id" element={<ReceiveTask />} />
        <Route path="review" element={<Review />} />
        <Route path="transfers" element={<Transfers />} />
        <Route path="transfers/new" element={<TransferForm />} />
        <Route path="transfers/:id" element={<TransferDetail />} />
        <Route path="purchase-requests" element={<PurchaseRequests />} />
        <Route path="delivery-requests" element={<DeliveryRequests />} />
        <Route path="production" element={<Production />} />
        <Route path="production/:id" element={<ProductionDetail />} />
        <Route path="inventory/warehouse" element={<Stock mode="warehouse" />} />
        <Route path="inventory/outlets" element={<Stock mode="outlets" />} />
        <Route path="inventory/stock/:locId" element={<Stock mode="any" />} />
        <Route path="inventory/variance" element={<Variance />} />
        <Route path="items" element={<Items />} />
        <Route path="recipes" element={<Recipes />} />
        <Route path="opname" element={<Opname />} />
        <Route path="opname/new" element={<OpnameForm />} />
        <Route path="opname/templates" element={<OpnameTemplates />} />
        <Route path="opname/:id" element={<OpnameDetail />} />
        <Route path="assets" element={<Assets />} />
        <Route path="payables" element={<Payables />} />
        <Route path="ledger" element={<Ledger />} />
        <Route path="adjustments" element={<Adjustments />} />
        <Route path="sales-import" element={<SalesImport />} />
        <Route path="cash" element={<Cash />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="reports/:tab" element={<Reports />} />
        <Route path="settings/:tab" element={<SettingsPage />} />
        <Route path="audit" element={<AuditLog />} />
        <Route path="reminders" element={<Reminders />} />
        <Route path="consignment" element={<Consignment />} />
        <Route path="consignment-recap" element={<ConsignmentRecap />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider><Gate /></AuthProvider>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}
